import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import {
 Col, Modal, InputGroup, Form, 
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { FaExclamationCircle } from 'react-icons/fa';
import { FaArrowDownShortWide, FaArrowUpWideShort } from 'react-icons/fa6';
import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../../../../context/AuthContext';
import DeleteConfirmationModal from '../../../DeleteModal';
import { PermissionContext } from '../../../../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../../../../context/SideBarRefreshContext';

const DataReactTable = () => {
  const [approvedData, setApprovedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const { apiGlobal } = useContext(AuthContext);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
    const { permissionsAccess } = useContext(PermissionContext);
    const { sideBarRefresh } = useContext(SideBarRefreshContext); 
    const [sortOrder, setSortOrder] = useState('asc');
    const [sortColumn, setSortColumn] = useState('pDAte'); // This will track the column being sorted  

  // state for hold id for delete row
  const [rowId, setRowId] = useState();

  // Search filter states
  const [searchAgentName, setSearchAgentName] = useState('');
  const [searchPaymentDate, setSearchPaymentDate] = useState('');

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchApprovedData = async () => {
    try {
      const url = await fetch(`${apiGlobal}account_data.php`);
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        setApprovedData(data.data);
      } else {
        setApprovedData([]);
        console.error('Something Went Wrong While fetching Payment Pending list');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchApprovedData();
  }, [refresh, sideBarRefresh?.adminPaymentApprovedRefresh]);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Filter logic
  const filteredData = approvedData.filter((agent) => {
    const matchAgentName = agent.staff_name?.toLowerCase().includes(searchAgentName.toLowerCase());
    const matchPaymentDate = agent.payment_date?.toLowerCase().includes(searchPaymentDate.toLowerCase());
    return matchAgentName && matchPaymentDate;
  });

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);


  const handleDeleteModalShow = (id) => {
    setDeleteModalShow(true);
    setRowId(id);
  };

  const onDeleteHandler = async () => {
      if (!rowId) {
        alert('Please select a row to delete'); 
      }
      // console.log(rowId);

      const formData = new FormData();
      formData.append('id', rowId);

      try {
        const url = await fetch(`${apiGlobal}/payment_undo.php`, {
          method: 'POST',
          body: formData,
        });
        const response = await url.json();
        if (response.status) {
          setDeleteModalShow(false);
          fetchApprovedData();
          setRowId();
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
  };

  const handleSort = (column) => {
    const newSortOrder = sortColumn 
    === column && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
  
    const sortedData = [...filteredData].sort((a, b) => {
      if (column === 'pDAte') {
        return newSortOrder === 'asc'
          ? new Date(a.payment_date) - new Date(b.payment_date)
          : new Date(b.payment_date) - new Date(a.payment_date);
      } if (column === 'sType') {
        return newSortOrder === 'asc'
          ? a.staff_type.localeCompare(b.staff_type)
          : b.staff_type.localeCompare(a.staff_type);
      } if (column === 'sName') {
        return newSortOrder === 'asc'
          ? a.staff_name.localeCompare(b.staff_name)
          : b.staff_name.localeCompare(a.staff_name);
      } if (column === 'amount') {
        const amountA = parseFloat(a.balance); // Convert string balance to number
        const amountB = parseFloat(b.balance); // Convert string balance to number
  
        return newSortOrder === 'asc' ? amountA - amountB : amountB - amountA;
      }
      return 0;
    });
  
    setApprovedData(sortedData);
    setSortOrder(newSortOrder);
    setSortColumn(column); // Update the current sorted column
  };


    // use Effect to add keyframes for the pulse animation
    useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);
  
  

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px', // Add gap between the input fields
          alignItems: 'center', // Vertically align input fields and button
          flexWrap: 'wrap', // Make sure the filters stay in a single line
        }}
      >
        <h5
          className="mb-2"
          style={{
            color: '#495057',
            alignSelf: 'center',
            marginRight: '20px',
            fontWeight: '600',
          }}
        >
          Filter Payment
        </h5>
        <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search by Agent Name"
            value={searchAgentName}
            onChange={e => setSearchAgentName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchPaymentDate}
            onChange={e => setSearchPaymentDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>
        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchAgentName('');
            setSearchPaymentDate('');
          }}
        >
          Clear Filters
        </Button>
        <Button
          variant="outline-danger"
          style={{
                    borderRadius: '25px',
                    padding: '8px 16px',
                    marginLeft: '2px',
                    alignSelf: 'center',
                  }}
          className="mt-3"
          onClick={() => {
                    setRefresh(prev => !prev);
                  }}
        >
          Refresh
        </Button>
        
      </div>

      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
          <tr>
            <th># </th>
            <th 
              onClick={() => handleSort('pDAte')}
              style={{ cursor: 'pointer' }}
            >Payment Date {sortColumn === 'pDAte' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('sType')}
              style={{ cursor: 'pointer' }}
            >
              Staff Type {sortColumn === 'sType' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('sName')}
              style={{ cursor: 'pointer' }}
            >
              Staff Name {sortColumn === 'sName' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th
              onClick={() => handleSort('amount')}
              style={{ cursor: 'pointer' }}
            >Booking Amount {sortColumn === 'amount' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
            </th>
            <th>Status</th>
          
            {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.edit === 1 && (
                          <th>Action</th>
          )}       
            
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{
                               textAlign: 'center',
                   padding: '50px',
                   backgroundColor: '#f8d7da',
                   borderRadius: '8px',
                   marginTop: '20px',
                               color: '#721c24',
                   fontSize: '16px',
                             }}
                >
                  <div
                    style={{
               fontSize: '48px',
               marginBottom: '20px',
               color: '#e63946',
               animation: 'pulse 1.5s infinite ease-in-out',
               display: 'inline-block',
               }}
                  >
                    <FaExclamationCircle />
                  </div>
                  <p>No Approved Payment Data Available</p>
                </div>
                {/* <h3>No Approved Data Available</h3> */}
              </td>
            </tr>
          ) : (
            currentItems.map((booking, index) => (
              <tr
                key={booking.id}
                style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f2f2', textAlign: 'center' }}
              >
                <td>{index + 1}</td>
                <td>{formatDate(booking.payment_date)}</td>
                <td>{booking.staff_type}</td>
                <td>{booking.staff_name}</td>
                <td>{booking.balance}</td>
                <td>
                  <span style={{ color: 'green' }}>
                    {booking.status === '1' && 'Approved'}
                  </span>
                </td>
                {permissionsAccess?.[5]?.master_id === '6'
                          && permissionsAccess?.[5]?.edit === 1 && (
                          <td>
                            {booking.payment_type !== '2' ? (
                              <Button 
                                type="button"
                                variant="warning"
                                title="undo"
                                size="sm"
                                onClick={() => handleDeleteModalShow(booking.id)}
                              ><span className="lnr lnr-undo text-black" />
                              </Button> 
                             ) : 'NA'}

                          </td>
                          )}
                
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <div
        style={{
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {currentItems.length !== 0 && (
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
 ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
        )}
       
      </div>



      <DeleteConfirmationModal
        show={deleteModalShow}
        handleClose={() => setDeleteModalShow(false)}
        handleDelete={onDeleteHandler}
        message="Are you sure you want to Undo this Payment Record?"
        title="Confirm undo Record"
        buttontext="Undo"
      />
    </div>
  );
};

export default DataReactTable;
